import { RedirectModal } from './redirect-modal'

export default RedirectModal
